import { PaymentSocketData, Session } from '../horizon-payment-getaway.model';

export class PaymentSocketDataVM implements PaymentSocketData {
  sessionId: string;
  paymentStatus: 'success' | 'error' | 'warning' | 'info';
  transactionType: string;
  paymentDetails: {
    amount: number;
    currency: string;
    AttemptCount: number;
    SuccessCount: number;
    FailureCount: number;
    ErrorCount: number;
  };
  errors?: Array<string>;
  constructor(
    data: Session,
    paymentStatus: 'success' | 'error' | 'warning' | 'info'
  ) {
    this.paymentStatus = paymentStatus;
    this.setValues(data);
  }

  private setValues(data: Session): void {
    this.sessionId = '';
    this.transactionType = data.VariableData.transactionType?.Value;
    this.paymentDetails = {
      amount: data.VariableData.grandTotalAmount?.Value,
      currency: data.VariableData.currency?.Value,
      AttemptCount: data.PaymentDetails.AttemptCount,
      SuccessCount: data.PaymentDetails.SuccessCount,
      FailureCount: data.PaymentDetails.FailureCount,
      ErrorCount: data.PaymentDetails.ErrorCount,
    };
    this.errors = [
      data.VariableData.errorMessage?.Value,
      data.VariableData.GenesysCloudErrorMessage?.Value,
    ];
  }
}
